import Layout from '@/components/layout/index.vue'

export default {
  path: 'performanceAppraisal',
  name: 'PerformanceAppraisal',
  meta: {},
  component: Layout,
  redirect: { name: 'PerformanceAppraisal.EvaluationSystem' },
  children: [
    {
      path: 'evaluationSystem',
      name: 'PerformanceAppraisal.EvaluationSystem',
      meta: {},
      component: () => import(/* webpackChunkName: "evaluationSystem" */ '@/views/purchaser/performanceAppraisal/evaluationSystem/index.ts')
    },
    {
      path: 'evaluationSystem/add',
      name: 'PerformanceAppraisal.EvaluationSystem.Add',
      meta: { title: 'performanceAppraisal.evaluationSystem.addEvaluationSystem', dep: 'PerformanceAppraisal.EvaluationSystem' },
      component: () => import(/* webpackChunkName: "evaluationSystem" */ '@/views/purchaser/performanceAppraisal/evaluationSystem/add.ts')
    },
    {
      path: 'evaluationSystem/modify/:id',
      name: 'PerformanceAppraisal.EvaluationSystem.Modify',
      meta: { title: 'performanceAppraisal.evaluationSystem.modifyEvaluationSystem', dep: 'PerformanceAppraisal.EvaluationSystem' },
      component: () => import(/* webpackChunkName: "evaluationSystem" */ '@/views/purchaser/performanceAppraisal/evaluationSystem/modify.ts')
    },
    {
      path: 'evaluationSystem/copy/:id',
      name: 'PerformanceAppraisal.EvaluationSystem.Copy',
      meta: { title: 'performanceAppraisal.evaluationSystem.modifyEvaluationCopy', dep: 'PerformanceAppraisal.EvaluationSystem' },
      component: () => import(/* webpackChunkName: "evaluationSystem" */ '@/views/purchaser/performanceAppraisal/evaluationSystem/copy.ts')
    },
    {
      path: 'evaluationSystem/detail/:id',
      name: 'PerformanceAppraisal.EvaluationSystem.Detail',
      meta: { title: 'common.detail', dep: 'PerformanceAppraisal.EvaluationSystem' },
      component: () => import(/* webpackChunkName: "evaluationSystem" */ '@/views/purchaser/performanceAppraisal/evaluationSystem/detail.ts')
    },
    {
      path: 'performanceAppraisal',
      name: 'PerformanceAppraisal.PerformanceAppraisal',
      meta: {},
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/index.ts')
    },
    {
      path: 'performanceAppraisal/add',
      name: 'PerformanceAppraisal.PerformanceAppraisal.Add',
      meta: { title: 'performanceAppraisal.performanceAppraisal.pageTitle.processAdd', dep: 'PerformanceAppraisal.PerformanceAppraisal' },
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/add.ts')
    },
    {
      path: 'performanceAppraisal/mark/:assessSystemNo/:judgeType/:processNo/:purchaseUnitNo',
      name: 'PerformanceAppraisal.PerformanceAppraisal.Mark',
      meta: { title: 'performanceAppraisal.performanceAppraisal.pageTitle.mark', dep: 'PerformanceAppraisal.PerformanceAppraisal' },
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/mark.ts')
    },
    {
      path: 'performanceAppraisal/viewMark',
      name: 'PerformanceAppraisal.PerformanceAppraisal.ViewMark',
      meta: { title: 'performanceAppraisal.performanceAppraisal.pageTitle.viewMark', dep: 'PerformanceAppraisal.PerformanceAppraisal' },
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/viewMark.ts')
    },
    {
      path: 'performanceAppraisal/viewResult/:processNo',
      name: 'PerformanceAppraisal.PerformanceAppraisal.ViewResult',
      meta: { title: 'performanceAppraisal.performanceAppraisal.pageTitle.viewResult', dep: 'PerformanceAppraisal.PerformanceAppraisal' },
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/viewResult.ts')
    },
    {
      path: 'performanceAppraisal/viewApprovalResult/:processNo',
      name: 'PerformanceAppraisal.PerformanceAppraisal.ViewApprovalResult',
      meta: { title: 'performanceAppraisal.performanceAppraisal.pageTitle.viewResult', dep: 'PerformanceAppraisal.PerformanceAppraisal' },
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/viewApprovalResult.ts')
    },
    {
      path: 'performanceAppraisal/detail',
      name: 'PerformanceAppraisal.PerformanceAppraisal.Detail',
      meta: {},
      component: () => import(/* webpackChunkName: "performanceAppraisal" */ '@/views/purchaser/performanceAppraisal/performanceAppraisal/detail.ts')
    }
  ]
}
